import React from "react";
import { Button } from "../ui/button";

type ResendTimerProps = {
  isRunning: boolean;
  label: string;
  onResend: () => void;
};

const ResendTimer = ({ isRunning, label, onResend }: ResendTimerProps) => {
  return (
    <div className="flex items-center gap-2 text-[14px] font-bold">
      {isRunning ? (
        <p className="text-foreground">
          Time remaining: <span className="text-primary">{label}</span>
        </p>
      ) : (
        <>
          <p className="text-foreground">Didn't receive the code?</p>
          <Button
            type="button"
            variant="link"
            onClick={onResend}
            className="h-auto p-0 text-[14px] font-bold text-primary"
          >
            Resend OTP
          </Button>
        </>
      )}
    </div>
  );
};

export default ResendTimer;
